import { publicClient } from '@/core/publicClient';

export const rescuedAnimalsPublicApi = {
  search: async (params?: Record<string, any>) => {
    const response = await publicClient.get('/public/rescued-animals', { params });
    return response.data; // { data, total, page, pageSize }
  },

  getById: async (id: number) => {
    const response = await publicClient.get(`/public/rescued-animals/${id}`);
    return response.data;
  },
};
